import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MoonIcon, SunIcon } from "lucide-react";

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") === "dark";
    setIsDark(savedTheme);
  }, []);

  // FIX-3: Removed /home special-case that was silently stripping dark-theme
  // and never restoring it on SPA navigation. Now applies consistently on all routes.
  useEffect(() => {
    if (isDark) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [location.pathname, isDark]);

  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    localStorage.setItem("theme", newTheme ? "dark" : "light");
    document.body.classList.toggle("dark-theme", newTheme);
  };

  return (
    <div className="theme-switch-wrapper" onClick={toggleTheme}>
        {isDark ? <SunIcon/> : <MoonIcon/>}
    </div>
  );
};

export default ThemeToggle;
